/* template */
<template><page><base-container><div :class='["cube-popup-list-item"]'><popup-content></popup-content></div><div :class='["cube-popup-list-item"]'><popup-position></popup-position></div><div :class='["cube-popup-list-item"]'><popup-transition></popup-transition></div></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_e4d6bfcc"}'>
.cube-popup-list-item
  margin-bottom 20px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_e4d6bfcc"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_e4d6bfcc"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_e4d6bfcc"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'popup-position':getComponent(require("./popup-position.mpx?isComponent&outputPath=components%2Fpopup-position27af6990%2Findex")),'popup-transition':getComponent(require("./popup-transition.mpx?isComponent&outputPath=components%2Fpopup-transition23ed9fbc%2Findex")),'popup-content':getComponent(require("./popup-content.mpx?isComponent&outputPath=components%2Fpopup-contentc0bc60c0%2Findex")),'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-popup':getComponent(require("../../../packages/mpx-cube-ui/src/components/popup/index.mpx?isComponent&outputPath=components%2Findex106ca599%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>